import { render, staticRenderFns } from "./compoTest.vue?vue&type=template&id=7a5731b1"
import script from "./compoTest.vue?vue&type=script&lang=js"
export * from "./compoTest.vue?vue&type=script&lang=js"
import style0 from "./compoTest.vue?vue&type=style&index=0&id=7a5731b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports